export default "__VITE_ASSET__y7lCT$mR__"